export default {
  symbol: "BTC/2"
};
